/**
 * Configuração do formulário de Viagens
 */

// Estrutura dos campos do formulário
export const formStructure = [
  // Linha 1: Código de Integração e Número da Carga
  [
    {
      name: 'CodigoIntegracao',
      label: 'Código de Integração',
      type: 'text',
      component: 'FormField',
      placeholder: 'Código de integração (opcional)',
      colProps: { md: 6 },
      maxLength: 50
    },
    {
      name: 'NumeroCarga',
      label: 'Número da Carga',
      type: 'text',
      component: 'FormField',
      placeholder: 'Número da carga associada',
      colProps: { md: 6 },
      maxLength: 50
    }
  ],
  // Linha 2: Busca de Veículo (Placa)
  [
    {
      name: 'VeiculoSearch',
      label: 'Veículo (Placa)',
      component: 'SearchSelect',
      placeholder: 'Digite a placa para buscar (ex: ABC1234)',
      colProps: { md: 12 },
      minSearchLength: 3,
      validation: {
        required: 'Veículo é obrigatório'
      },
      customOnChange: true
    }
  ],
  // Linha 3: Busca de Motorista
  [
    {
      name: 'MotoristaSearch',
      label: 'Motorista',
      component: 'SearchSelect',
      placeholder: 'Digite o nome do motorista para buscar',
      colProps: { md: 12 },
      minSearchLength: 3,
      validation: {
        required: 'Motorista é obrigatório'
      },
      customOnChange: true
    }
  ],
  // Campos ocultos (serão preenchidos automaticamente)
  [
    {
      name: 'NumeroPlaca',
      label: 'Placa',
      type: 'text',
      component: 'FormField',
      colProps: { md: 4 },
      disabled: true
    },
    {
      name: 'NumeroFrota',
      label: 'Frota',
      type: 'text',
      component: 'FormField',
      colProps: { md: 4 },
      disabled: true
    },
    {
      name: 'NomeMotorista',
      label: 'Nome do Motorista',
      type: 'text',
      component: 'FormField',
      colProps: { md: 4 },
      disabled: true
    }
  ],
  // Linha 5: UF Origem e Destino
  [
    {
      name: 'IdUfOrigem',
      label: 'UF Origem',
      component: 'SearchSelect',
      placeholder: 'Digite para buscar a UF de origem',
      colProps: { md: 6 },
      minSearchLength: 1,
      maxResults: 30,
    },
    {
      name: 'IdUfDestino',
      label: 'UF Destino',
      component: 'SearchSelect',
      placeholder: 'Digite para buscar a UF de destino',
      colProps: { md: 6 },
      minSearchLength: 1,
      maxResults: 30,
    },
  ],
  // Linha 6: Cidade Origem e Destino
  [
    {
      name: 'IdCidadeOrigem',
      label: 'Cidade Origem',
      component: 'SearchSelect',
      placeholder: 'Digite para buscar a cidade de origem',
      colProps: { md: 6 },
      minSearchLength: 2,
      maxResults: 30,
    },
    {
      name: 'IdCidadeDestino',
      label: 'Cidade Destino',
      component: 'SearchSelect',
      placeholder: 'Digite para buscar a cidade de destino',
      colProps: { md: 6 },
      minSearchLength: 2,
      maxResults: 30,
    },
  ],
  // Linha 7: Datas
  [
    {
      name: 'DataInicio',
      label: 'Data de Início',
      type: 'date',
      component: 'FormField',
      placeholder: 'Data de início da viagem',
      colProps: { md: 6 },
      validation: {
        required: 'Data de início é obrigatória'
      }
    },
    {
      name: 'DataFim',
      label: 'Data de Fim',
      type: 'date',
      component: 'FormField',
      placeholder: 'Data de fim da viagem',
      colProps: { md: 6 }
    }
  ],
  // Linha 8: KM Rodado
  [
    {
      name: 'TotalKmRodado',
      label: 'Total KM Rodado',
      type: 'number',
      component: 'FormField',
      placeholder: 'Total de quilômetros rodados',
      colProps: { md: 12 },
      step: '0.01',
      min: 0
    }
  ],
  // Linha 9: Valores de Frete
  [
    {
      name: 'ValorFreteLiquido',
      label: 'Valor Frete Líquido (R$)',
      type: 'number',
      component: 'FormField',
      placeholder: 'Valor do frete líquido',
      colProps: { md: 6 },
      step: '0.01',
      min: 0
    },
    {
      name: 'ValorFreteBruto',
      label: 'Valor Frete Bruto (R$)',
      type: 'number',
      component: 'FormField',
      placeholder: 'Valor do frete bruto',
      colProps: { md: 6 },
      step: '0.01',
      min: 0
    }
  ],
  // Linha 10: Notas Fiscais
  [
    {
      name: 'NotasFiscais',
      label: 'Notas Fiscais',
      type: 'textarea',
      component: 'FormField',
      placeholder: 'Notas fiscais relacionadas (separadas por vírgula)',
      colProps: { md: 12 },
      rows: 3
    }
  ]
];

// Seções do formulário
export const formSections = (initialValues) => [
  {
    title: 'Dados da Viagem',
    rows: [0] // Linha 1: Código de Integração e Número da Carga
  },
  {
    title: 'Veículo e Motorista',
    rows: [1, 2, 3] // Linhas 2-4: Busca Veículo, Busca Motorista, Campos preenchidos
  },
  {
    title: 'Localização',
    rows: [4, 5] // Linhas 5-6: UF e Cidade Origem/Destino
  },
  {
    title: 'Datas e Quilometragem',
    rows: [6, 7, 8] // Linhas 7-9: Datas, KM Rodado, Valores de Frete
  },
  {
    title: 'Notas Fiscais',
    rows: [9] // Linha 10: Notas Fiscais
  }
];

// Validação do formulário
export const validateForm = (values) => {
  const errors = {};

  // Validações obrigatórias
  if (!values.IdVeiculo) {
    errors.IdVeiculo = 'ID do Veículo é obrigatório';
  }
  if (!values.NumeroPlaca) {
    errors.NumeroPlaca = 'Placa do Veículo é obrigatória';
  }
  if (!values.IdMotorista) {
    errors.IdMotorista = 'ID do Motorista é obrigatório';
  }
  if (!values.NomeMotorista) {
    errors.NomeMotorista = 'Nome do Motorista é obrigatório';
  }
  if (!values.DataInicio) {
    errors.DataInicio = 'Data de Início é obrigatória';
  }

  // Validação de placa (formato brasileiro)
  if (values.NumeroPlaca && !/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(values.NumeroPlaca.replace(/[^A-Z0-9]/g, ''))) {
    errors.NumeroPlaca = 'Placa inválida. Use formato ABC1234 ou ABC1D23';
  }

  // Validação de datas
  if (values.DataInicio && values.DataFim) {
    const dataInicio = new Date(values.DataInicio);
    const dataFim = new Date(values.DataFim);
    if (dataFim < dataInicio) {
      errors.DataFim = 'Data de Fim não pode ser anterior à Data de Início';
    }
  }

  // Validação de KM
  if (values.TotalKmRodado && values.TotalKmRodado < 0) {
    errors.TotalKmRodado = 'Total KM Rodado não pode ser negativo';
  }

  // Validação de Valores de Frete
  if (values.ValorFreteLiquido && values.ValorFreteLiquido < 0) {
    errors.ValorFreteLiquido = 'Valor Frete Líquido não pode ser negativo';
  }

  if (values.ValorFreteBruto && values.ValorFreteBruto < 0) {
    errors.ValorFreteBruto = 'Valor Frete Bruto não pode ser negativo';
  }

  // Validação lógica: Frete Líquido geralmente é menor que Bruto
  if (values.ValorFreteLiquido && values.ValorFreteBruto) {
    const liquido = parseFloat(values.ValorFreteLiquido);
    const bruto = parseFloat(values.ValorFreteBruto);
    if (liquido > bruto) {
      errors.ValorFreteLiquido = 'Valor Líquido não pode ser maior que o Valor Bruto';
    }
  }

  return errors;
};
